import { render, staticRenderFns } from "./labDetails.vue?vue&type=template&id=f298d3e8"
import script from "./labDetails.vue?vue&type=script&lang=js"
export * from "./labDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports